
import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Divider, Typography } from "@mui/material";
import LoginIcon from '@mui/icons-material/Login';
import { ResetPassword } from "../../engine/baseApiClient";
import { useSearchParams } from "react-router-dom";
import validator   from "validator"
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import navigationPaths from "../../engine/navigationPaths";
import CircularProgress from "@mui/material/CircularProgress";
import MDButton from "components/MDButton";
import ToastMessage from "components/toastMessage";
function NewPasswordComponent(props) {   
 
    const [isPasswordChanged, setIsPasswordChanged] = React.useState(false);
    const [isError, setIsError] = React.useState(false);
    const [isPasswordValid, setIsPasswordValid] = React.useState(true);    
    const [searchParams, setSearchParams] = useSearchParams();
    const [showPassword, setShowPassword] = React.useState(false);
    const [isInProgress, setisInProgress] = React.useState(false);

    const navigate = useNavigate();
    
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
     event.preventDefault();
    };

    const standalone = props.standalone;
    
    const redirectToLogin=()=>{      
            navigate(navigationPaths().LogIn);          
    }
    

    const handleSubmit = async (e) => {
        e.preventDefault();       
       
        const data = new FormData(e.currentTarget);
        if(!validate(data)){        
            setIsPasswordValid(false);
            return; 
        }
        var resetPasswordData = {
            token: searchParams.get("token"),
            newPassword: data.get("password")         
        };      
        try{        
            setisInProgress(true);    
            var response = await ResetPassword(resetPasswordData);       
            if(response.status == "OK"){      
                setIsPasswordChanged(true);
                setIsError(false);
            }
            else{
                setIsError(true);
            }
        }
        catch(e){
            setIsError(true);
        }
        finally{
            setisInProgress(false);    
        }
    };

    const validate= (data) => {         
        return checkPassword(data.get("password"));
    }   

    const checkPassword = (value)=>{       
        var isValid = validator.isStrongPassword(value,{
            minLength: 12, minLowercase: 1, minUppercase: 1, minNumbers: 1, minSymbols: 1
        })
        setIsPasswordValid(isValid);
        return isValid;
      }

    return (       
        <div>       
            <Box  component="form" onSubmit={handleSubmit} noValidate>
            <ToastMessage open={isPasswordChanged} onClose={ () => setIsPasswordChanged(false)} message={"Twoje hasło zostało zmienione"}/> 
            <TextField margin="normal" required error={!isPasswordValid} onChange={(e)=>checkPassword(e.target.value)} fullWidth name="password" helperText="Hasło powinno mieć co najmniej 12 znaków, wielkie i małe litery,cyfry oraz 2 znaki specjalne" label="Twoje nowe hasło" type={showPassword ? 'text' : 'password'} id="password" 
                        InputProps={{
                            endAdornment: 
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Pokaż hasło"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                        }} 
                    />          
                <Divider/>
                {isError && <Typography sx={{ mt: 2}} color="error.light" margin="normal" align="center" fullWidth name="invalid-data">Twój link wygasł, spróbuj ponownie</Typography>} 
                {(!(isPasswordChanged) || standalone) && <MDButton color='info' type="submit" id="login" fullWidth variant="contained" sx={{ mt:2, mb: 2 }} endIcon={isInProgress ? null: <LoginIcon />}> {isInProgress ?<CircularProgress size={"1.55rem"} sx={{color:"white"}}  /> : "Zmień hasło"}</MDButton>}
                {isPasswordChanged && !standalone &&<MDButton color='info' onClick={redirectToLogin} type="submit" id="login" fullWidth variant="contained" sx={{ mt:2, mb: 2 }} endIcon={<LoginIcon />}>Zaloguj się</MDButton>}
            </Box>
     
    </div>
    );
}
export default NewPasswordComponent;
